import type { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { unref } from 'vue';
import { getApi } from './api';

interface GetAccountGeofenceParams {
  [key: string]: any;
}

/**
 * Query hook for fetching a single geofence by account and geofence ID
 * @param accountId - Account ID (reactive or static)
 * @param geofenceId - Geofence ID (reactive or static)
 * @param params - Optional query parameters (reactive or static)
 * @returns Vue Query result with geofence data
 */
export default (
  accountId: Ref<number> | number,
  geofenceId: Ref<number> | number,
  params?: Ref<GetAccountGeofenceParams> | GetAccountGeofenceParams
) => {
  return useQuery({
    queryKey: [
      'account-geofence',
      () => unref(accountId),
      () => unref(geofenceId),
      () => unref(params)
    ],
    queryFn: () => {
      const { api, baseURL } = getApi();
      const actualAccountId = unref(accountId);
      const actualGeofenceId = unref(geofenceId);
      const actualParams = unref(params) || {};

      return api.get(`/api/accounts/${actualAccountId}/geofences/${actualGeofenceId}`, {
        baseURL,
        params: actualParams
      }).then(res => res.data.data);
    },
    enabled: !!(unref(accountId) && unref(geofenceId)),
  });
};

